import ChipInGlimpse from './chip_in_glimpse'
import { connect } from 'react-redux'

import { destroy } from 'redux-form'
import { inflateUserTxns } from 'redux/modules/user_txns'
import { getCampaignSelector } from 'redux/selectors/campaign'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)

  return {
    operatingRemotely:
      campaign.operatingRemotely || state.funding_sources.operatingRemotely,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onUnmount() {
      // This is here (and not in the route's onLeave) because of lifecycle cosiderations. The onLeave callback
      // is called before everything is unmounted, so if we clear the form (and other things)
      // when before the send flow's components are unmounted, they will do unneccsary update, or worse -
      /// they will do updates with null (or undefined) values.
      dispatch(destroy('chip_in'))
      dispatch(inflateUserTxns(campaignId))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChipInGlimpse)
